// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as AuthRepo$PorterinFeature from "./AuthRepo.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as AuthDummyRepo$PorterinFeature from "./AuthDummyRepo.mjs";

function getAuthRepo(param) {
  if (Config$PorterinUtils.env === Environments$PorterinUtils.development) {
    return AuthDummyRepo$PorterinFeature;
  } else {
    return {
            checkCustomerExists: AuthRepo$PorterinFeature.checkCustomerExists,
            customerLogout: AuthRepo$PorterinFeature.customerLogout,
            validateOtp: AuthRepo$PorterinFeature.validateOtp,
            resendOtp: AuthRepo$PorterinFeature.resendOtp,
            customerSignUp: AuthRepo$PorterinFeature.customerSignUp,
            customerProfile: AuthRepo$PorterinFeature.customerProfile
          };
  }
}

export {
  getAuthRepo ,
}
/* Config-PorterinUtils Not a pure module */
